/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LeaderboardRouteImport } from './routes/leaderboard'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as GamesCabinetTransformerRouteImport } from './routes/games/cabinet-transformer'
import { Route as GamesAutomationDropRouteImport } from './routes/games/automation-drop'

const LeaderboardRoute = LeaderboardRouteImport.update({
  id: '/leaderboard',
  path: '/leaderboard',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const GamesCabinetTransformerRoute = GamesCabinetTransformerRouteImport.update({
  id: '/games/cabinet-transformer',
  path: '/games/cabinet-transformer',
  getParentRoute: () => rootRouteImport,
} as any)
const GamesAutomationDropRoute = GamesAutomationDropRouteImport.update({
  id: '/games/automation-drop',
  path: '/games/automation-drop',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/leaderboard': typeof LeaderboardRoute
  '/games/automation-drop': typeof GamesAutomationDropRoute
  '/games/cabinet-transformer': typeof GamesCabinetTransformerRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/leaderboard': typeof LeaderboardRoute
  '/games/automation-drop': typeof GamesAutomationDropRoute
  '/games/cabinet-transformer': typeof GamesCabinetTransformerRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/leaderboard': typeof LeaderboardRoute
  '/games/automation-drop': typeof GamesAutomationDropRoute
  '/games/cabinet-transformer': typeof GamesCabinetTransformerRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/leaderboard'
    | '/games/automation-drop'
    | '/games/cabinet-transformer'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/leaderboard'
    | '/games/automation-drop'
    | '/games/cabinet-transformer'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/leaderboard'
    | '/games/automation-drop'
    | '/games/cabinet-transformer'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRoute
  LeaderboardRoute: typeof LeaderboardRoute
  GamesAutomationDropRoute: typeof GamesAutomationDropRoute
  GamesCabinetTransformerRoute: typeof GamesCabinetTransformerRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/leaderboard': {
      id: '/leaderboard'
      path: '/leaderboard'
      fullPath: '/leaderboard'
      preLoaderRoute: typeof LeaderboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/games/cabinet-transformer': {
      id: '/games/cabinet-transformer'
      path: '/games/cabinet-transformer'
      fullPath: '/games/cabinet-transformer'
      preLoaderRoute: typeof GamesCabinetTransformerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/games/automation-drop': {
      id: '/games/automation-drop'
      path: '/games/automation-drop'
      fullPath: '/games/automation-drop'
      preLoaderRoute: typeof GamesAutomationDropRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRoute,
  LeaderboardRoute: LeaderboardRoute,
  GamesAutomationDropRoute: GamesAutomationDropRoute,
  GamesCabinetTransformerRoute: GamesCabinetTransformerRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
